import endpoints from "../utils/endpoints";
import { message } from "antd";
import { Api } from "./api";
import { removeEmpty } from "../utils/objectUtils";
import { notificationError, notificationSucces } from "./notification";
import { IAvaliableGamesByWager, IJackpotInfo } from "../pages/NewJackpot";
import { IJackpotHistoryItem } from "../pages/JackpotHistory";

export async function getJackpotHistory(){
  let res: IJackpotHistoryItem[] = []

  await Api.get(endpoints.getJackpotHistory).then((response) => {
    if(response.status === 200 && response.data) {
        if(response.data.error) {
            notificationError(`${response.data.message}`)
        } else {
            res = response.data.list
        }
    }  else {
      notificationError('Could not get jackpot history')
    }
  }).catch((err: string) => {
    notificationError('Could not get jackpot history')
  })
  
  return res
}